module.exports = __webpack_public_path__ + "img/icon-white-28.42153efc.svg";